import React, { Component } from "react"; 
import ConfirmarOperacionTransfer from "../../../pages/transferencias/ConfirmarOperacionTransfer";
import {mensajeExito} from "../../../generico/MensajeSistemaToast"
import TransferCuentasPropiasService from "../../../../services/transferencias/TransferCuentasPropiasService";
import { splitImporte } from "../../../generico/utils/FormatoInput";
import { trackPromise } from "react-promise-tracker";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faPlus, faFilePdf} from "@fortawesome/free-solid-svg-icons";
import AuthService from "../../../../services/login/auth.service";

export default class TransferCuentasPropias extends Component {
 
  constructor(props) {
    super(props);
    this.newTransfer = this.newTransfer.bind(this);

  }

  componentDidMount() {
    this.setState({ listaFactura: false });
  }


  newTransfer() {
    this.props.returnDataPaso3();
    this.firstStep.click();
  }

  descargar = async () => {
   // nroOperacion, cuentaTitular, tipo, moneda, cuentaDebito,cuentaCredito,importeDebito, importeCredito, titularCuentaDestino
    await trackPromise(
      TransferCuentasPropiasService.descagarComponente("Transferencia entre Cuentas",this.props.nroOperacion, this.props.cuentaOrigen +" - "+AuthService.getSocio().nombreCompleto, this.props.cuentaOrigenSelected.descripcion, this.props.cuentaOrigenSelected.moneda, this.props.cuentaOrigen, this.props.cuentaDestino + ' - ' + this.props.cuentaDestinoSelected.denominacion, this.props.importe, this.props.importe, AuthService.getSocio().nombreCompleto)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    this.setState({ listaFactura: true });
   // return listaFactura;
  };

  render() {
    if(this.props.currentStep===3 && !this.state.listaFactura){
      mensajeExito("La Transferencia se Realizó Correctamente")
    }  
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuentas
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="container-fluid">
        {this.props.cuentaOrigenSelected !== undefined && (
          <ConfirmarOperacionTransfer
            idModal="idModalConfirm3"           
            title="Transferencias Entre Cuentas Propias"
            items={this.props.itemsConfirm}
            detalleCuentaBox={this.props.detalleCuenta}
            tipoCuenta={this.props.cuentaOrigenSelected.descripcion}
            moneda={this.props.cuentaOrigenSelected.moneda}
            nroOperacion={this.props.nroOperacion}
          />
        )}
        </div>
        <div className="row"> 
        <div className="col-lg-6 col-md-6"></div>
        <div className="col-lg-3 col-md-3 btn-consulta">
        <button
            onClick={this.newTransfer}
            type="button"
            className="btn btn-cu-quintary"
            >
           <FontAwesomeIcon icon={faPlus} /> Nueva Transacción
        </button>
        </div>
        <div className="col-lg-3 col-md-3">
        <button onClick={this.descargar}
            type="button"
            className="btn btn-cu-primary">
          <FontAwesomeIcon icon={faFilePdf} />  Descargar Comprobante
          </button>
          <button
            hidden
            ref={(a) => (this.firstStep = a)}
            onClick={this.props.firstStep}></button>
        </div>
        </div>
      </div>
    );
  }
}
